import Organization from '@/api/admin_organizations.api.js'

/*eslint-disable */
export const getList = ({ commit }, data) => {
  return Organization.getList(data)
    .then(response => {
      commit("SET_ORGANIZATIONS", response.data)
      return response;
    })
    .catch(err => err);
}

export const create = ({ commit }, data) => {
  return Organization.create(data)
    .then(response => response)
    .catch(err => err);
}

export const getDetail = ({ commit }, data) => {
  return Organization.getDetail(data)
    .then(response => {
      commit("SET_ORGANIZATION", response.data)
      return response;
    })
    .catch(err => err);
}

export const update = ({ commit }, data) => {
  return Organization.update(data)
    .then(response => response)
    .catch(err => err);
}

export const deleteOrganization = ({ commit }, data) => {
  return Organization.delete(data)
    .then(response => response)
    .catch(err => err);
}

export const getCollectionOrg = ({ commit }, data) => {
  return Organization.getCollectionOrg(data)
    .then(response => {
      commit("SET_COLLECTIONS", response.data)
      return response
    })
    .catch(err => err)
}

export const getTemplateOrg = ({ commit }, data) => {
  return Organization.getTemplateOrg(data)
    .then(response => {
      commit("SET_TEMPLATES", response.data)
      return response
    })
    .catch(err => err)
}

export const settingTemplateOrg = ({ commit }, data) => {
  return Organization.settingTemplate(data)
    .then(response => {
      return response
    })
    .catch(err => err)
}
/*eslint-enable */